import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA }  from '@angular/material';
import { MatDialogRef } from '@angular/material';
import { PublicacionService } from '../../core/publicacion.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-eliminarpub',
  templateUrl: './eliminarpub.component.html',
  styleUrls: ['./eliminarpub.component.css']
})
export class EliminarpubComponent implements OnInit {

  constructor(public snackBar: MatSnackBar, public publicacionService: PublicacionService, public thisDialogRef: MatDialogRef<EliminarpubComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onCloseConfirm(id: string) {
    this.thisDialogRef.close('Confirm');
    this.publicacionService.eliminarPublicacion(id);
    this.snackBar.open('La publicación ha sido eliminada.', 'CERRAR', {
      duration: 4000
    });
  }

  onCloseCancel() {
    this.thisDialogRef.close('Cancel');
  }

}



// WEBPACK FOOTER //
// ./src/app/publicaciones/eliminarpub/eliminarpub.component.ts